import { ApplicationUser, CaseStatusEnum } from "@src/apis/ModularClient";

export class SharedHeadsOfTermsService {
  dataLoading: boolean;

  static $inject = ["$q"];

  constructor(private $q: ng.IQService) {}

  isCurrentUserAllowedToSendChat(
    isBroker: boolean,
    dealStatus: CaseStatusEnum,
    isReferredToConnect: boolean,
    isConnectUser: boolean,
  ) {
    if (!isBroker || (isBroker && !isReferredToConnect)) {
      return true;
    } else if (
      isBroker &&
      isConnectUser &&
      (dealStatus == CaseStatusEnum.SentToPackager || dealStatus == CaseStatusEnum.Applied)
    ) {
      return true;
    } else if (isBroker && dealStatus != CaseStatusEnum.SentToPackager && dealStatus != CaseStatusEnum.Applied) {
      return true;
    } else {
      return false;
    }
  }
}

// AngularJS service registration
